"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorLayerGroupFactory = void 0;
var VectorLayerGroup_1 = require("./VectorLayerGroup");
var VectorLayer_1 = require("../../vector/VectorLayer");
var FilterType_1 = require("../../../map/filters/FilterType");
var VectorLayerStrategy_1 = require("../../vector/VectorLayerStrategy");
var VectorLayerGroupFactory = /** @class */ (function () {
    function VectorLayerGroupFactory() {
        var _this = this;
        this.getLayerGroups = function (layerConfig, styleFactory) {
            var layerGroups = new Array();
            for (var _i = 0, layerConfig_1 = layerConfig; _i < layerConfig_1.length; _i++) {
                var layer = layerConfig_1[_i];
                layerGroups.push(_this.getLayerGroup(layer, styleFactory));
            }
            return layerGroups;
        };
        this.getLayerGroup = function (layerConfig, styleFactory) {
            var url = layerConfig.url;
            var ref = layerConfig.ref || (layerConfig.type.toString() + ((layerConfig.subType) ? ("_" + layerConfig.subType.toString()) : ""));
            var layerCount = 0;
            var lg = new VectorLayerGroup_1.VectorLayerGroup(layerConfig.type, layerConfig.subType, layerConfig.displayName, ref, url, layerConfig.legend);
            if (layerConfig.urlParams) {
                lg.urlParams = layerConfig.urlParams;
            }
            lg.maxFeatureCount = layerConfig.maxFeatureCount || 3000;
            lg.strategy = layerConfig.strategy;
            lg.zoomToDataBounds = layerConfig.zoomToDataBounds;
            lg.useWfsBboxRequestParameter = layerConfig.useWfsBboxRequestParameter;
            lg.queryable = true;
            lg.filterOptions = layerConfig.filterOptions || { filterType: FilterType_1.FilterType.NotSet, filters: [] };
            lg.wfsParams = layerConfig.wfsParams;
            //default to false if not present
            lg.alwaysLoadOnZoom = layerConfig.alwaysLoadOnZoom || false;
            if (layerConfig.overrideFeatureAdd) {
                lg.featureAdd = layerConfig.overrideFeatureAdd;
            }
            if (!layerConfig.wfsParams && (layerConfig.strategy === VectorLayerStrategy_1.VectorLayerStrategy.All || layerConfig.strategy === VectorLayerStrategy_1.VectorLayerStrategy.Bbox)) {
                if (console) {
                    console.error("You must specify the WFS parameter source when using VectorLayerStrategy.All/Bbox: " + ref);
                }
            }
            if (layerConfig.useWfsBboxRequestParameter && (!layerConfig.wfsParams || !layerConfig.wfsParams.WfsBboxRequestParameter)) {
                if (console) {
                    console.error("You must specify the WfsBboxRequestParameter on the WFS parameter source when the layer has useWfsBboxRequestParameter set to true: " + ref);
                }
            }
            if (typeof layerConfig.displayInLegend != "undefined") {
                lg.displayInLegend = layerConfig.displayInLegend;
            }
            if (typeof layerConfig.queryable != "undefined" && layerConfig.queryable === false) {
                lg.queryable = false;
            }
            if (layerConfig.filterOptions != null) {
                //merge the two
                lg.filterOptions = __assign(__assign({}, lg.filterOptions), layerConfig.filterOptions);
            }
            if (layerConfig.useSelectedStyle === true) {
                lg.useSelectedStyle = true;
                lg.style = styleFactory.getSelectedStyle(layerConfig.type, layerConfig.subType);
            }
            else {
                lg.style = styleFactory.getStyle(layerConfig.type, layerConfig.subType);
            }
            if (layerConfig.displayInLayerSwitcher === false) {
                lg.displayInLayerSwitcher = false;
            }
            if (layerConfig.visibleOnFirstLoad === false) {
                lg.visibleOnFirstLoad = false;
            }
            if (layerConfig.visibleOnLoad === true) {
                lg.visibleOnLoad = true;
            }
            if (layerConfig.restrictMapExtentToDataBounds === true) {
                lg.restrictMapExtentToDataBounds = true;
            }
            if (layerConfig.useBbox_WithFilter) {
                lg.useBbox_WithFilter = true;
            }
            if (layerConfig.allowZoomToLoadedDataBounds === true) {
                lg.allowZoomToLoadedDataBounds = true;
            }
            if (typeof layerConfig.layers !== "undefined" && layerConfig.layers !== null) {
                for (var _i = 0, _a = layerConfig.layers; _i < _a.length; _i++) {
                    var t1 = _a[_i];
                    layerCount += 1;
                    var l = new VectorLayer_1.VectorLayer(layerConfig.subType, lg, t1.minZoom, t1.maxZoom, (t1.layerName || ref + "_" + layerCount), lg.style, lg.queryable);
                    if (t1.wktProperty) {
                        l.wktProperty = t1.wktProperty;
                        l.points = t1.pointsOnly;
                    }
                    lg.layers.push(l);
                }
            }
            return lg;
        };
    }
    return VectorLayerGroupFactory;
}());
exports.VectorLayerGroupFactory = VectorLayerGroupFactory;
//# sourceMappingURL=VectorLayerGroupFactory.js.map